module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('bloquear-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showBloquear
    },
    on: {
      "close": function($event) {
        _vm.showBloquear = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "show": _vm.showCriar
    },
    on: {
      "close": function($event) {
        _vm.showCriar = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('criar-atendimento-modal', {
    attrs: {
      "id": _vm.atendimento_id,
      "item": _vm.itens,
      "show": _vm.showCriarAtendimento
    },
    on: {
      "close": function($event) {
        _vm.showCriarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('bloquear-periodo-modal', {
    attrs: {
      "show": _vm.showBloquearPeriodo,
      "distribuicao_contrato_id": _vm.$route.params.distribuicaoContratoId
    },
    on: {
      "close": function($event) {
        _vm.showBloquearPeriodo = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('editar-atendimento-modal', {
    attrs: {
      "tipo": "subgrupo",
      "item": _vm.atendimento,
      "show": _vm.showEditarAtendimento
    },
    on: {
      "criarAtendimento": function($event) {
        _vm.criarAtendimento($event)
      },
      "close": function($event) {
        _vm.showEditarAtendimento = false
      },
      "atualizar": function($event) {
        _vm.getDataTable()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "title": "Bloquear por período"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bloquearPeriodo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-ban",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Bloquear por período")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "title": "Criar atendimento"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.criarAtendimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v(" Criar atendimento")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nome_subgrupo),
      expression: "filtros.nome_subgrupo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Entre com NOME do SUBGRUPO"
    },
    domProps: {
      "value": (_vm.filtros.nome_subgrupo)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "nome_subgrupo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.sexo),
      expression: "filtros.sexo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("AMBOS")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("MASCULINO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("FEMININO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (De)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_inicial),
      expression: "filtros.data_inicial"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_inicial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_inicial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Período (Até)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_final),
      expression: "filtros.data_final"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtros.data_final)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_final", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {}, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.filtrar
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_subgrupo.subgrupo.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("sexo")(item.sexo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloIdade")([item.idade_minima, item.idade_maxima])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_atendimento)) + " "), _c('br'), _vm._v(" (" + _vm._s(_vm._f("diaDaSemana")(item.data_atendimento)) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("intervaloHoras")([item.hora_inicial, item.hora_final])))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo == 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Atendimentos Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_atendimento_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo == 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Locais Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Locais Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_local))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Locais Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Locais Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_local_consumida))])])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "2px",
        "margin": "0",
        "text-align": "center"
      }
    }, [(item.tipo_consumo != 1) ? _c('strong', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v("---")]) : _c('table', {
      staticClass: "table table-bordered table-hover table-striped"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', [_c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticStyle: {
        "background-color": "blue",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Distribuídos (Modelo)"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_original))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Disponíveis"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#c40233",
        "color": "white"
      },
      attrs: {
        "title": "Atendimentos por Paciente Bloqueados"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_bloqueada))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "#ffdb58",
        "color": "black"
      },
      attrs: {
        "title": "Atendimentos por Paciente Consumidos"
      }
    }, [_vm._v(_vm._s(item.quantidade_paciente_consumida))])])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "title": "Bloquear Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.bloquear(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-ban",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "title": "Criar Atendimentos"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.criar(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-plus",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "title": "Editar Atendimento"
      },
      on: {
        "click": function($event) {
          _vm.editar(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Atendimentos de Subgrupo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Filtros:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("Controle")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Idade")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Horário")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Atendimentos")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Locais")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "7%"
    }
  }, [_vm._v("Pacientes")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Ação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', [_vm._v("M")]), _vm._v(" "), _c('th', [_vm._v("D")]), _vm._v(" "), _c('th', [_vm._v("B")]), _vm._v(" "), _c('th', [_vm._v("C")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9f3bd50e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/distribuicoes/atendimentos/agendasSubgrupos.vue
// module id = 888
// module chunks = 0